/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendGetProjectDto } from '../../models/backend-get-project-dto';
import { BackendGetProjectRequestDto } from '../../models/backend-get-project-request-dto';

export interface ProjectsSubscribeToProject$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendGetProjectRequestDto;
}

export function projectsSubscribeToProject$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsSubscribeToProject$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendGetProjectDto>> {
  const rb = new RequestBuilder(rootUrl, projectsSubscribeToProject$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendGetProjectDto>;
    }),
  );
}

projectsSubscribeToProject$XWwwFormUrlencoded.PATH = '/api/projects/exchange/project-subscriptions/{id}/';
